var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRoundedChevron = function SvgRoundedChevron(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 14 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M7 14c-3.864 0-7-3.136-7-7s3.136-7 7-7 7 3.136 7 7-3.136 7-7 7m0-1.167A5.83 5.83 0 0 0 12.833 7 5.83 5.83 0 0 0 7 1.167 5.83 5.83 0 0 0 1.167 7 5.83 5.83 0 0 0 7 12.833m-1.565-2.436a.51.51 0 0 1-.007-.734L8.25 7l-2.82-2.649a.497.497 0 0 1 .013-.734c.192-.186.508-.179.72.02l2.856 2.697a.92.92 0 0 1 0 1.345l-2.855 2.698c-.192.178-.55.192-.728.02"
  })));
};
export default SvgRoundedChevron;